import StoreSearchList from '@!/Store/SearchList/containers/StoreSearchList'
import StoreApp from '@!/Store/Common/containers/StoreApp'
import { AppProvider } from '@!/providers'

const StoreSearchListApp = (props) => {
  return (
    <AppProvider>
      <StoreApp {...props}>
        <StoreSearchList
          type={props.type}
          searchTerm={props.search_term}
          page={props.page}
          genreTabName={props.genre_tab_name}
          searchTags={props.search_tags}
          metaTag={props.meta_tag}
        />
      </StoreApp>
    </AppProvider>
  )
}

export default StoreSearchListApp
